/* istanbul ignore file */

import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import type { CSSProp } from 'styled-components';

import { IconHeartOutlined } from '../../foundations/Iconography/IconHeartOutlined';
import { IconHeartSolid } from '../../foundations/Iconography/IconHeartSolid';
import { ButtonInner } from '../Button/ButtonInner/ButtonInner';
import {
  FAVOURITE_BUTTON_CLASSNAME,
  FAVOURITE_ICON_TRANISITION_DURATION_IN_MS,
  FAVOURITE_TRANSITION_CLASSNAME,
} from './constants/favouriteButton';
import { buttonSize } from './buttonSizes.styles';
import * as styles from './FavouriteButton.styles';
import type { ActionButtonSize } from 'client-ribbons-design-system/types/actionButtons';
import type { IconSize } from 'client-ribbons-design-system/types/icons';

export interface FavouriteButtonProps {
  active?: boolean;
  className?: string;
  iconStyles?: CSSProp;
  onClick: VoidFunction;
  size: ActionButtonSize;
}

export const FavouriteButton = ({
  active,
  className,
  iconStyles,
  onClick,
  size,
}: FavouriteButtonProps) => {
  const iconSize: IconSize = size === 'small' ? 16 : 24;
  const sizeStyles = size === 'small' ? styles.small : styles.large;

  return (
    <div css={styles.favouriteIconTransition}>
      <SwitchTransition mode="in-out">
        <CSSTransition
          classNames={FAVOURITE_TRANSITION_CLASSNAME}
          in={active}
          key={`${FAVOURITE_TRANSITION_CLASSNAME}-${active}`}
          timeout={FAVOURITE_ICON_TRANISITION_DURATION_IN_MS}
        >
          <button
            aria-label="Favourite"
            aria-pressed={active}
            className={
              className ? `${FAVOURITE_BUTTON_CLASSNAME} ${className}` : FAVOURITE_BUTTON_CLASSNAME
            }
            css={[buttonSize(false, false), styles.favouriteButton, sizeStyles]}
            onClick={onClick}
            type="button"
          >
            <ButtonInner>
              {active ? (
                <IconHeartSolid
                  color={`var(--brand-purple-base)`}
                  css={iconStyles}
                  height={iconSize}
                  width={iconSize}
                />
              ) : (
                <IconHeartOutlined
                  color={`var(--brand-purple-base)`}
                  css={iconStyles}
                  height={iconSize}
                  width={iconSize}
                />
              )}
            </ButtonInner>
          </button>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};
